<template>
    <div class="image__wrapper" data-animate="fadeIn">
        <img 
        v-if="isImage" 
        v-simple-parallax="{ scale: 1.1, delay: 0.4 }" 
        :src="fullPath" 
        alt=""
    >
    <video 
        v-else-if="isVideo" 
        :src="fullPath" 
        autoplay 
        loop 
        muted 
        playsinline
    ></video>
    </div>
</template>

<script>
    export default {
        props: {
          fields: [Array,Object],
        },
        computed: {
            fullPath() {
                return `${this.$store.state.base_directory}${this.fields['Image'].replace(/^public\//, '')}`;
            },
            isImage() {
                return /\.(jpg|jpeg|png|gif|webp)$/i.test(this.fields['Image']);
            },
            isVideo() {
                return /\.(mp4|webm|ogg)$/i.test(this.fields['Image']);
            }
        }
    }
</script>

<style scoped>
.image__wrapper{
    padding-top: 131%;
    position: relative;
    overflow: hidden;
}
img{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
}
video{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
}
@media (max-width: 1024px) {
    .image__wrapper{
        padding-top: 80%;
    }
}
</style>